<!-- 显示用户 logo， app名称 ，下载提示 -->
<template>
  <div  class="top-banner-out" v-if="showBanner">
    <div class="top-banner" v-if="innerBanner">
      <div class="t-app">
        <img onerror="this.style.display='none'" v-if="icon"
             :src="icon" alt="">
        <span class="app-name" v-if="appName">{{appName}}</span>
        <div class="t-tip">
          <span class="t-line"></span>
          <span class="t-w">话题</span>
        </div>
      </div>
      <span v-if="!detail" class="to-app openappAndroidwx wx-launch-app-btn-parent">打开APP参与话题</span>
      <span v-if="detail" @click="openTopic" class="to-app">查看完整话题</span>
      <Popover v-if="showPopover" :appName="appName" @openAppOrTopic="openAppOrTopic" @openTopic="openTopic"  :topicInfo="topicInfo"></Popover>
    </div>
  </div>

</template>

<script>
  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  // const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1
  import Popover from './Popover'

  export default {
    name: 'topBanner',
    props: ['appName', 'detail', 'topicInfo'],
    data () {
      return {
        icon: '',
        sid: '',
        showPopover: 0,
        innerBanner: false,
        showBanner: _agent || 0
      }
    },
    beforeMount () {
      if (_agent) {
        window.gUserConfig.downloadBarPosition = window.gUserConfig.downloadBarPosition || 0
        // 下载条放置到底部
        if (window.gUserConfig.downloadBarPosition == 0) {
          this.innerBanner = false
          this.showBanner = false
        } else if (window.gUserConfig.downloadBarPosition == 1) {
          this.innerBanner = true
          this.showBanner = true
        } else {
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          // 显示在顶部和底部
          if (scrollTop > 50) {
            this.innerBanner = false
          } else {
            this.innerBanner = true
          }
          window.addEventListener('scroll', () => {
            if (scrollTop > 50) {
              this.innerBanner = false
            } else {
              this.innerBanner = true
            }
          })
        }
      }

    },
    watch: {
      appName (newValue, oldValue) {
        this.appName = newValue
      }
    },
    created () {
      this.sid = this.$route.params.sid
      this.icon = `https://${this.sid}oss.newaircloud.com/global/user/${this.sid}/mobile/img/icon.png`
    },
    mounted () {
    },
    methods: {
      openApp: function (e) {
        var _this = this
        // _this.showPopover = 1
        _this.$emit('headToApp')
      },
      openTopic: function (n) {
        var _this = this
        _this.showPopover = typeof n !== 'undefined' ? n : 1
      },
      openAppOrTopic: function (e) {
        var _this = this
        _this.$emit('topicDetail')
      }
    },
    components: {
      Popover
    }
  }
</script>

<style scoped>

  .top-banner-out{
    position: relative;
    height: 1rem;
  }

  .top-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 1rem;
    padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.011rem solid #eeeeee;
    background: #fff;
    z-index: 9999;
  }

  .t-app {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    max-width: calc(100% - 2.8rem);
    line-height: 0.5rem;
  }

  .t-app .app-name {
    margin-right: 0.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 1.7rem);
  }

  .t-app img {
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 0.2rem;
  }

  .t-tip {
    width: 1.2rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 0.2rem;
  }

  .t-line {
    display: inline-block;
    height: 0.36rem;
    width: 0.02rem;
    background: #DDDDDD;
    margin-right: 0.2rem;
    box-sizing: initial;
  }

  .to-app {
    padding: 0.11rem 0.26rem;
    font-size: 0.26rem;
    color: var(--themeColor);
    border: 0.0111rem solid var(--themeColor);
    background: #ffffff;
    border-radius: 0.24rem;
    line-height: normal;
  }

</style>



// WEBPACK FOOTER //
// topBanner.vue?468f55dd